import { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import { Routings } from "./route";
import ProtectedRoute from "../util/ProtectedRoute";
import ErrorFallback from "../component/ErrorFallback";

import Login from "../auth/login/Login";
import GetOtp from "../auth/forgot-password/GetOTP";
import VerifyOtp from "../auth/forgotpassword/VerifyOtp";
import ResetPassword from "../auth/forgotpassword/ResetPassword";
import GlobalLoader from "../component/GlobalLoader";
import ParentLinkStudentRegistration from "../portal/parentLinkStudentRegistration/ParentLinkStudentRegistration";
import PaymentFail from "../portal/parentLinkStudentRegistration/paymentFail";
import PaymentSuccess from "../portal/parentLinkStudentRegistration/paymentSuccess";
import ParentLinkInvoicePayment from "../portal/parentLinkInvoicePayment/ParentLinkInvoicePayment";
import RegisteredSuccess from "../portal/parentLinkStudentRegistration/RegisteredSuccess";
import PageNotFound from "../portal/pageNotFound/PageNotFount";

function DefaultRoutes() {
  return (
    <div className="App">
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          window.location.reload();
        }}
      >
        <BrowserRouter basename={`/${process.env.REACT_APP_CONTEXT_PATH}`}>
          <Suspense fallback={<GlobalLoader loading={true} />}>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route
                path="/registered-success"
                element={<RegisteredSuccess />}
              />
              <Route path="/payment-fail" element={<PaymentFail />} />
              <Route path="/login?program=sa" element={<Login />} />
              <Route path="/forgot-password/otp" element={<GetOtp />} />
              <Route
                path="/forgot-password/verify-otp"
                element={<VerifyOtp />}
              />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/parentLink"
                element={<ParentLinkStudentRegistration />}
              />
              <Route
                path="/invoicePayment"
                element={<ParentLinkInvoicePayment />}
              />

              <Route path="*" element={<PageNotFound />} />

              {Routings.map((RouteDetails: any, index: any) => (
                <Route
                  key={index}
                  path={RouteDetails.path}
                  element={
                    <ProtectedRoute
                      roles={RouteDetails.roles}
                      lastElement={Routings.length === index + 1}
                    >
                      {RouteDetails.component}
                    </ProtectedRoute>
                  }
                />
              ))}
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default DefaultRoutes;
